import React, { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Report from "../../../models/Report";
import DataTable from "../dataTable";

const initialTable = {
    page: 1,
    term: "",
    sort: "percentage",
    order: "desc",
    limit: 25,
};

export default function EntityTeeTimeRequestEngagement({
    description = "The percentage of each entity's current members who have ever made a tee-time booking request.",
    fetchReport = Report.entityTeeTimeRequestEngagement,
    membersColumn = "Members with requests",
    percentageColumn = "% with requests",
    sortLabel = "Engagement %",
    title = "Entity tee-time request engagement",
}) {
    const [loading, setLoading] = useState(true);
    const [table, setTable] = useState(initialTable);
    const [totalRecords, setTotalRecords] = useState(0);
    const [data, setData] = useState([]);

    const getData = useCallback(async (params) => {
        setLoading(true);
        const response = await fetchReport(params);
        setData(response.items);
        setTotalRecords(response.total);
        setTable(params);
        setLoading(false);
    }, [fetchReport]);

    useEffect(() => {
        getData(initialTable);
    }, [getData]);

    const headers = [
        { key: "entity", text: "Entity" },
        { key: "totalMembers", text: "Total members" },
        { key: "activeMembers", text: membersColumn },
        { key: "percentage", text: percentageColumn },
    ];
    const tableData = data.map((item) => {
        const percentage = Number(item.percentage || 0);
        return {
            entity: {
                value: <Link to={`/entities/${item._id}`}>{item.name}</Link>,
                search: item.name,
            },
            totalMembers: {
                value: item.totalMembers,
                search: item.totalMembers,
            },
            activeMembers: {
                value: item.activeMembers,
                search: item.activeMembers,
            },
            percentage: {
                value: `${percentage.toFixed(2)}%`,
                search: percentage,
            },
        };
    });

    return (
        <>
            <h4>{title}</h4>
            <p>{description}</p>
            <DataTable
                loading={loading}
                headers={headers}
                data={tableData}
                totalRecords={totalRecords}
                page={table.page}
                onChange={getData}
                searchTerm={table.term}
                sort={table.sort}
                order={table.order}
                limit={table.limit}
                sortOptions={[
                    { text: sortLabel, key: "percentage" },
                    { text: "Entity", key: "name" },
                    { text: "Total members", key: "totalMembers" },
                    {
                        text: membersColumn,
                        key: "activeMembers",
                    },
                ]}
                pagination
            />
        </>
    );
}
